import { styled } from '@linaria/react';
import { useSpring, animated } from 'react-spring';

import Box from './Box';
import Code from './Code';
import Wrapper from './Wrapper';

function TranslateDemo({ variant, x, y }) {
  const unit = variant === 'translate-percentage' ? '%' : 'px';
  const styles = useSpring({
    transform: `translate(${x}${unit}, ${y}${unit})`,
  });

  return (
    <Wrapper>
      {variant === 'translate-px-flow' ? (
        <BoxRow>
          <Box extra />
          <Box style={styles} />
          <Box extra />
        </BoxRow>
      ) : (
        <Box style={styles} />
      )}
      <Code>
        transform: translate({x}
        {unit}, {y}
        {unit});
      </Code>
    </Wrapper>
  );
}

const BoxRow = styled.div`
  display: flex;
  gap: 16px;
`;

export default TranslateDemo;
